<template>
  <!-- <swiper :options="swiperOption"> -->
  <!-- v-for="(item, index) in List" :key="index" -->
  <div class="container">
    <div class="row">
      <div
        v-for="(item, index) in NewestAudios.slice(0, 3)"
        :key="index"
        :virtualIndex="index"
        class="col-lg-4 col-md-6 mt-2"
      >
        <!-- card -->
        <div class="card m-2 col-lg-12 col-md-12" style="height: 100%">
          <!-- favorite icon -->
          <span
            class="_addtoFav py-2 px-3 position-absolute pt-4"
            @click.stop="UpdateStatus(item, index)"
          >
            <i class="fa fa-heart text-white fa-2x" v-if="item.IsFavorite"></i>
            <i class="far fa-heart text-white fa-2x" v-else></i>
          </span>
          <!-- image card -->
          <img
            v-if="item.ImageURL"
            :src="baseURL + item.ImageURL"
            alt=""
            height="250"
            class="card-img-top border-bottom pt-3"
          />
          <img
            v-else
            src="/static/img/enNotAvail.png"
            alt=""
            height="250"
            class="card-img-top border-bottom pt-3"
          />
          <!-- play audio icon -->
          <span class="_addtoFav PlayIcon py-2 px-3 position-absolute"
            @click.stop="PlayAudio(item)"
          >
            <i
              class="fas fa-play-circle text-primary fa-4x"
              style="
                crusor: pointer;
                background-color: white;
                border-radius: 50%;
              "
            ></i>
          </span>
          <!-- card info -->
          <div class="card-body position-relative">
            <div class="justify-content-between">
              <h4 class="card-title text-truncate font-weight-bold">
                {{ item.Name }}
              </h4>
              <p>{{ item.AuthorName }}</p>
              <!-- <i
                          v-if="IsLoved"
                          class="fa fa-heart font-2x text-warning"
                        ></i> -->
              <!-- <i  class="far fa-heart text-warning"></i> -->

              <!-- <router-link
                        to="/product-detail"
                        class="square-40 bg-white rounded-circle text-dark card-shadow"
                      >
                        <i class="fa fa-heart text-warning"></i>
                        <i class="far fa-heart"></i>/
                      </router-link> -->
            </div>
            <div class="card-subtitle text-muted text-truncate my-2">
              {{ item.Brief }}
            </div>
            <!-- <router-link :to="{ name: 'AudioDetails', params: { ID: item.ID } }">
            <button class="rounded-pill text-white btn btn-primary">
              {{ $t("Continue") }}
            </button>
          </router-link> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
    <div class="swiper-pagination" slot="pagination"></div> -->
</template>

<script>
// import "swiper/swiper-bundle.css";
// import { swiper, swiperSlide } from "vue-awesome-swiper";
import { domain } from "@/globalComponents.js";

export default {
  computed: {
    NewestAudios() {
      debugger;
      return this.$store.state.HomeList.NewestAudios;
    },
  },
  // components: {
  //   swiper,
  //   swiperSlide,
  // },
  name: "audios",
  data() {
    return {
      baseURL: domain,
    };
  },
  methods: {
    UpdateStatus(item, index) {
      if (this.$store.state.auth.isUserLoggedIn()) {
        let model = {};
        model.libraryID = item.ID;
        this.$store
          .dispatch("DataList/ToggleUserFavorite", model)
          .then(() => {
            // if (response.status == "ok") {
            debugger;
            this.NewestAudios[index].IsFavorite =
              !this.NewestAudios[index].IsFavorite;
            // this.Favorites = response.data.data;
            // }
          })
          .catch(() => {});
        return false;
      } else {
        this.$toasted.show(this.$t("PleaseLoginFirst"), {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
        });
        return true;
      }
    },
    PlayAudio(URL) {
      debugger
      this.$store.commit("AudioUrl", URL.URL);
      debugger
      this.$store.dispatch("auth/SetActivityLog", URL.ID);
      debugger
    },
  },
  created() {},
};
</script>

<style lang="scss">
.PlayIcon {
  top: 45%;
  right: 30px;
  z-index: 5000;
}
._cartBtn {
  left: 1.25rem;
}

._addtoFav {
  cursor: pointer;
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  color: #f78500 !important;
  text-shadow: 4px 4px 5px #a0a0a0;
  // background-color: white;
  // border-radius: 50%;
  // opacity: 1 !important;
  // width: 70px !important;
  // height: 70px !important;
  top: 90% !important;
}

.swiper-button-prev {
  color: #f78500 !important;
  text-shadow: 4px 4px 5px #a0a0a0;
  // background-color: white;
  // border-radius: 50%;
  // opacity: 1 !important;
  // width: 70px !important;
  // height: 70px !important;
  top: 90% !important;
}

.swiper-pagination-bullet-active {
  background: #f78500 !important;
}

.swiper-pagination-bullet {
  margin-right: 10px;
}

.swiper-pagination {
  margin: auto !important;
  align-items: center !important;
  position: relative;
  padding: auto;
}

.carousel-example .swiper-container .swiper-slide {
  text-align: center;
  font-size: 38px;
  font-weight: 700;
  background-color: #eee;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  min-height: 300px;
}
</style>
